import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

import { registerNavSection } from "./shell/navigation";

registerNavSection({ key: "sales", spoke: "sales", title: "Sales", icon: ShoppingCartIcon, order: 36, entries: [
  { label: "Orders", to: "/app/sales/orders", permission: "sales.order.view" },
  { label: "New order", to: "/app/sales/orders/new", permission: "sales.order.create" },
  { label: "Blanket orders", to: "/app/sales/blanket-orders", permission: "sales.blanket.view" },
  { label: "Recurring orders", to: "/app/sales/recurring-orders", permission: "sales.recurring.view" },
  { label: "Returns (RMA)", to: "/app/sales/rmas", permission: "sales.rma.view" },
  { label: "Import orders", to: "/app/sales/imports", permission: "sales.import.run" },
] });
